webpackJsonp([49759960243555],{

/***/ 365:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Sunny Crest","author":"Brian Capouch"}},"mongodbOsconBlogposts":{"id":"5b3c10771a7d792030b15b01","path":"/barn/","post":{"childMarkdownRemark":{"html":"<p>It isn't known precisely when the barn was constructed, but it appears to be a bit newer than the main house.  It still retains almost all of its original features, including an elaborate metal ventilator on top, which has faux shingles on its base.</p>\n<p>The interior features a number of pens and gates between them, and a hay mow with sliding doors that allow hay to be thrown into a manger below.  It has two grain bins, and a milking stanchion.</p>\n<p><img src=\"./IMAGES/barnVentilator.jpg\" alt=\"Barn Ventilator\"></p>\n<center>\nThe top of the barn is adorned with a fancy ventilator\n</center>","frontmatter":{"title":"Barn"}}}}},"pathContext":{"id":"5b3c10771a7d792030b15b01"}}

/***/ })

});


// WEBPACK FOOTER //
// path---barn-8cbb27a2411d6f15b6cb.js